module.exports = __webpack_public_path__ + "static/media/animate-10.274db6f1.mp4";